import {isDevXd} from "../../ui-components/debug/is-dev";

export const addImageReferenceToProductTags = async (product, assetType, imageId, surfaceName, variableName) => {
    if (isDevXd()) console.log("CcEditor.addImageReferenceToProductTags writing image ID to product tags", assetType, imageId, surfaceName, variableName);

    // load tags
    let tags = await product.getTags() || {};


    const item = tags.imageSources?.find((item) => item.variableName === variableName && item.surfaceName === surfaceName);
    if (item) {
        if (
            item.assetType !== assetType ||
            item.assetId !== imageId
        ) {
            item.assetType = assetType;
            item.assetId = imageId;
            // save the product tags
            await product.setTags(tags);
        } else {
            // Data existed, no need to save
        }
    } else {

        if (!tags.imageSources) {
            tags.imageSources = [];
        }
        tags.imageSources.push({
            surfaceName: surfaceName,
            variableName: variableName,
            assetType: assetType,
            assetId: imageId
        });

        // save the product tags
        await product.setTags(tags);
    }



};
